/**
 * Счетчик метрики
 */

const metrikaId = 30683113;

export default metrikaId;